import ZoomInButton from './zoom-in-button';
import ZoomOutButton from './zoom-out-button';

const plugin = {
  pluginName: 'ZoomButtons',
  enabled: true,
  components:[{
    component: ZoomInButton,
    region: 'right-sidebar-top',
    sortOrder: 30
  },{
    component: ZoomOutButton,
    region: 'right-sidebar-top',
    sortOrder: 31
  }]
}

export default plugin;